export const trackAcknowledge = () =>
  Promise.race([
    new Promise(resolve => {
      const request = new XMLHttpRequest();
      request.addEventListener('load', resolve);
      request.open('GET', 'https://pixel.spotify.com/v1/cpua', true);
      request.send();
    }),
    new Promise(resolve => setTimeout(resolve, 1000)),
  ]);
